module.exports = __webpack_public_path__ + "static/assets/0d35033050b1b9e947577efecf2b27d6.svg";